'use client';

import React, { ReactNode } from 'react';
import Lottie from 'lottie-react';

import Header from '@/shared/Header';
import ProgressIndicator from '@/shared/Components/ProgressIndicator';
import { useGlobalStore } from '@/store';
import LoadingLottie from '@/lib/Button/assets/loading-lottie.json';

const Layout = ({ children }: { children: ReactNode }): JSX.Element => {
  const { paymentDetails } = useGlobalStore();
  const { loading } = paymentDetails;
  return (
    <div className="bg-primary-intense rounded-sm relative flex flex-col w-full h-[100vh] d:flex-row">
      <Header />
      {loading ? (
        <div className="h-full w-full bg-black-normal absolute bg-opacity-80 flex items-center justify-center z-10">
          <div className="w-2/5 d:w-1/4">
            <Lottie className="h-full" loop={true} animationData={LoadingLottie} />
          </div>
        </div>
      ) : (
        ''
      )}
      <div className="overflow-scroll h-full flex flex-col rounded-t-xl bg-white-normal d:w-70 d:static d:rounded-none d:z-10 d:m-4 d:mb-0 d:mx-2 d:rounded-xl d:h-[96%]">
        <ProgressIndicator />
        {children}
      </div>
    </div>
  );
};

export default Layout;
